<template>
  <v-navigation-drawer
      id="documentation-toc"
      v-scroll="onScroll"
      :floating="structure === false"
      :right="!$vuetify.rtl"
      app
      clipped
      color="transparent"
  >
    <template v-if="structure !== false">
      <ul class="pt-8 mb-6 documentation-toc">
        <li class="mb-2">
          <p class="body-3 text-uppercase text--primary">
            Contents
          </p>
        </li>

        <template v-for="(item, i) in internalToc">
          <li
              v-if="item.visible"
              :key="i"
              :class="{
              'documentation-toc__link--subheader': item.subheader,
              'mb-2': i + 1 !== internalToc.length,
              'primary--text': activeIndex === i,
              'text--disabled': activeIndex !== i
            }"
              :style="{
              borderColor: activeIndex === i ? 'currentColor' : undefined
            }"
              class="documentation-toc__link"
          >
            <a
                :href="`#${item.id}`"
                class="d-block"
                @click.stop.prevent="goTo(`#${item.id}`)"
                v-html="item.text"
            />
          </li>
        </template>
      </ul>
    </template>
  </v-navigation-drawer>
</template>
<script>
    export default {
        name: 'DocumentationToc',
        props: {
            contentSelector: String
        },
        data: () => ({
            activeIndex: 0,
            currentOffset: 0,
            internalToc: [],
            tocTimeout: 0,
            headings: [],
            structure: true
        }),
        computed: {
            toc() {
                return this.headings
                    .map(h => {
                        let text = h.innerText
                        const isSubheading = h.tagName.toLowerCase() === 'h3'
                        const isHeading = h.tagName.toLowerCase() === 'h2'
                        const isIntroduction = h.tagName.toLowerCase() === 'h1'
                        return {
                            id: h.id,
                            subheader: isSubheading,
                            text,
                            visible: isSubheading || isHeading || isIntroduction,
                        }
                    })
                    .filter(h => h.visible)
            },
        },
        mounted() {
            let headings = document.querySelectorAll(
                `${this.contentSelector} h2, ${this.contentSelector} h3, ${this.contentSelector} h4`
            )
            headings.forEach(h => h.id = this.kebabCase(h.innerText))
            this.headings = Array.prototype.slice.call(headings)
        },
        watch: {
            toc: {
                immediate: true,
                handler(val) {
                    if (!val.length) return
                    this.$nextTick(() => (this.internalToc = this.toc.slice()))
                },
            },
        },
        methods: {
            kebabCase(text) {
                return text.replace(/([a-z])([A-Z])/g, "$1-$2")
                    .replace(/\s+/g, '-')
                    .toLowerCase();
            },
            goTo(id) {
                document.querySelector(id).scrollIntoView({
                    behavior: 'smooth'
                });
            },
            findActiveIndex() {
                if (this.currentOffset < 100) {
                    this.activeIndex = 0
                    return
                }
                const list = this.toc.slice().reverse()
                const index = list.findIndex(item => {
                    const section = document.getElementById(item.id)
                    if (!section) return false
                    return section.offsetTop - 100 < this.currentOffset
                })
                const lastIndex = list.length - 1
                this.activeIndex = index > -1
                    ? lastIndex - index
                    : lastIndex
            },
            onScroll() {
                this.currentOffset = (
                    window.pageYOffset ||
                    document.documentElement.offsetTop ||
                    0
                )
                clearTimeout(this.timeout)
                this.timeout = setTimeout(this.findActiveIndex, 50)
            },
        },
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  video {
    width: 100% !important;
    max-width: 1200px;
    height: auto;
  }

  #documentation-toc {
    .supporter-group__title {
      padding-left: 8px;
    }
  }

  .documentation-toc {
    list-style-type: none !important;
    margin: 0;
    padding: 32px 0 0;
    text-align: left;
    width: 100%;

    li {
      border-left: 2px solid transparent;
      padding: 0 24px 0 8px;
    }

    li a {
      color: inherit;
      font-size: .875rem;
      font-weight: 400;
      text-decoration: none;
      transition: color .1s ease-in;
    }

    .supporter-group {
      justify-content: flex-start !important;
    }

    .documentation-toc__link--subheader {
      margin-left: 8px;
    }
  }
</style>